export function isDateStillValid(currentDate, dateValue) {
  const formattedDate = new Date(dateValue)
  if (formattedDate < currentDate) {
    return false
  }
  return true
}
